// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jes-O","field":"styles_field__33FV6","fieldCol":"styles_fieldCol__3wTBD","diffCol":"styles_diffCol__1fL1t","diff":"styles_diff__2sBvb"};